<template>
  <a-row :gutter="[8, 8]" style="padding: 8px; width: 300px">
    <a-col :span="24">
      <a-select
        placeholder="Seleccionar"
        show-search
        optionFilterProp="label"
        :value="props.selectedKeys[0]"
        @change="(value) => props.setSelectedKeys(value ? [value] : [])"
        :options="props.options"
        :loading="props.loading"
        v-bind="{ ...(props.mode ? { mode: props.mode } : {}) }"
        style="width: 100%"
      >
        <template #dropdownRender="{ menuNode: menu }">
          <a-row :gutter="[8, 8]">
            <a-col :span="24">
              <v-nodes :vnodes="menu" />
            </a-col>
            <a-col :span="24">
              <a-divider style="margin: 4px 0" />
            </a-col>
            <a-col :span="12">
              <a-button
                type="primary"
                @click="() => props.confirm()"
                size="small"
                block
              >
                <template #icon>
                  <FilterOutlined />
                </template>
                Buscar
              </a-button>
            </a-col>
            <a-col :span="12">
              <a-button @click="() => props.clearFilters()" size="small" block>
                <template #icon>
                  <CloseCircleOutlined />
                </template>
                Reiniciar
              </a-button>
            </a-col>
          </a-row>
        </template>
      </a-select>
    </a-col>
    <a-col :span="12">
      <a-button
        type="primary"
        @click="() => props.confirm()"
        size="small"
        block
      >
        <template #icon>
          <FilterOutlined />
        </template>
        Buscar
      </a-button>
    </a-col>
    <a-col :span="12">
      <a-button @click="() => props.clearFilters()" size="small" block>
        <template #icon>
          <CloseCircleOutlined />
        </template>
        Reiniciar
      </a-button>
    </a-col>
  </a-row>
</template>

<script setup>
import { CloseCircleOutlined, FilterOutlined } from '@ant-design/icons-vue';
import { defineProps } from 'vue';

const props = defineProps([
  'setSelectedKeys',
  'selectedKeys',
  'confirm',
  'clearFilters',
  'options',
  'loading',
  'mode'
]);

const VNodes = (_, { attrs }) => attrs.vnodes;
</script>
